import fetch from '../utils/fetch';


export function ocrinfo(params) {
  return fetch({
    method: 'GET',
    url: '/ocr/info',
    params
  })
}
